import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const areas = [
  {
    title: "Aposentados e Pensionistas",
    image:
      "https://assets.cdn.filesafe.space/vyxGSs9NtFYsqksgNt9c/media/6a31cd9ddd7879239a4f2003.webp",
    link: "/areas-de-atuacao/aposentados-e-pensionistas",
  },
  {
    title: "Policiais",
    image:
      "https://assets.cdn.filesafe.space/vyxGSs9NtFYsqksgNt9c/media/6a4273743a7f0c5468813aea.webp",
    link: "/areas-de-atuacao/policiais",
  },
  {
    title: "Professores",
    image:
      "https://assets.cdn.filesafe.space/vyxGSs9NtFYsqksgNt9c/media/6a31d57b602476018d6e58c3.webp",
    link: "/areas-de-atuacao/professores-quinquenios",
  },
  {
    title: "Profissionais da Saúde",
    image:
      "https://assets.cdn.filesafe.space/vyxGSs9NtFYsqksgNt9c/media/6a31d57b1b95dbb2c241c63f.webp",
    link: "/areas-de-atuacao/servidores-da-saude",
  },
  {
    title: "Imposto de Renda",
    image:
      "https://assets.cdn.filesafe.space/vyxGSs9NtFYsqksgNt9c/media/6a31d57b1b95dbb2c241c63a.webp",
    link: "/areas-de-atuacao/imposto-de-renda",
  },
];

const PracticeAreas = () => {
  return (
    <section
      id="atuacao"
      className="py-[10px] md:py-[50px] bg-white pt-[50px] pb-[50px]"
    >
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          className="text-left md:text-center max-w-4xl mx-auto mb-16 space-y-6"
        >
          <h2 className="text-[30px] md:text-[48px] lg:text-[48px] font-bold text-primary text-center font-serif">
            Áreas de Atuação
          </h2>
          <p className="text-muted-foreground leading-relaxed text-base">
            Com dedicação exclusiva aos servidores públicos, a Pinheiro
            Advocacia combina conhecimento técnico profundo e atuação
            estratégica para garantir a proteção integral da remuneração e
            aposentadoria de diversas categorias profissionais.
          </p>
          <div className="pt-4 flex justify-start md:justify-center">
            <p className="text-[#8a5d20] font-bold uppercase tracking-wider text-sm animate-pulse text-center">
              Clique no seu banner para saber mais
            </p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="flex flex-col items-center gap-12"
        >
          {/* Top row: 2 cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 w-full max-w-5xl">
            {areas.slice(0, 2).map((area, index) => {
              const content = (
                <>
                  <img
                    src={area.image}
                    alt={area.title}
                    className="w-full h-auto object-cover transition-transform duration-700 group-hover:scale-110"
                    loading="lazy"
                    decoding="async"
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors" />
                </>
              );

              const className =
                "group relative block overflow-hidden rounded-[2rem] shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border-4 border-accent";

              return (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-50px" }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                >
                  {area.link.startsWith("/") ? (
                    <Link to={area.link} className={className}>
                      {content}
                    </Link>
                  ) : (
                    <a href={area.link} className={className}>
                      {content}
                    </a>
                  )}
                </motion.div>
              );
            })}
          </div>

          {/* Middle row: 2 cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 w-full max-w-5xl">
            {areas.slice(2, 4).map((area, index) => {
              const content = (
                <>
                  <img
                    src={area.image}
                    alt={area.title}
                    className="w-full h-auto object-cover transition-transform duration-700 group-hover:scale-110"
                    loading="lazy"
                    decoding="async"
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors" />
                </>
              );

              const className =
                "group relative block overflow-hidden rounded-[2rem] shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border-4 border-accent";

              return (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-50px" }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                >
                  {area.link.startsWith("/") ? (
                    <Link to={area.link} className={className}>
                      {content}
                    </Link>
                  ) : (
                    <a href={area.link} className={className}>
                      {content}
                    </a>
                  )}
                </motion.div>
              );
            })}
          </div>

          {/* Bottom row: 1 card centered */}
          <div className="w-full max-w-5xl flex justify-center">
            <div className="w-full md:w-[calc(50%-1rem)]">
              {areas.slice(4).map((area, index) => {
                const content = (
                  <>
                    <img
                      src={area.image}
                      alt={area.title}
                      className="w-full h-auto object-cover transition-transform duration-700 group-hover:scale-110"
                      loading="lazy"
                      decoding="async"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors" />
                  </>
                );

                const className =
                  "group relative block overflow-hidden rounded-[2rem] shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border-4 border-accent";

                return (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-50px" }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                  >
                    {area.link.startsWith("/") ? (
                      <Link to={area.link} className={className}>
                        {content}
                      </Link>
                    ) : (
                      <a href={area.link} className={className}>
                        {content}
                      </a>
                    )}
                  </motion.div>
                );
              })}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default PracticeAreas;
